// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension="
// @generated from file container/v1/container.proto (package container.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type {
  BinaryReadOptions,
  FieldList,
  JsonReadOptions,
  JsonValue,
  PartialMessage,
  PlainMessage
} from '@bufbuild/protobuf'
import { Message, proto3, Timestamp } from '@bufbuild/protobuf'
import { CreationMethod, DateRange } from '../../asset/v1/asset_pb'
import { PaginationArguments, PaginationPageInfo } from '../../common/v1/pagination_pb'

/**
 * @generated from enum container.v1.ContainerType
 */
export enum ContainerType {
  /**
   * @generated from enum value: CONTAINER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTAINER_TYPE_FOLDER = 1;
   */
  FOLDER = 1,

  /**
   * @generated from enum value: CONTAINER_TYPE_WORKSPACE = 2;
   */
  WORKSPACE = 2,

  /**
   * @generated from enum value: CONTAINER_TYPE_ORG = 3;
   */
  ORG = 3
}
// Retrieve enum metadata with: proto3.getEnumType(ContainerType)
proto3.util.setEnumType(ContainerType, 'container.v1.ContainerType', [
  { no: 0, name: 'CONTAINER_TYPE_UNSPECIFIED' },
  { no: 1, name: 'CONTAINER_TYPE_FOLDER' },
  { no: 2, name: 'CONTAINER_TYPE_WORKSPACE' },
  { no: 3, name: 'CONTAINER_TYPE_ORG' }
])

/**
 * @generated from enum container.v1.FolderState
 */
export enum FolderState {
  /**
   * @generated from enum value: FOLDER_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FOLDER_STATE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: FOLDER_STATE_DRAFT = 2;
   */
  DRAFT = 2,

  /**
   * @generated from enum value: FOLDER_STATE_ARCHIVED = 3;
   */
  ARCHIVED = 3
}
// Retrieve enum metadata with: proto3.getEnumType(FolderState)
proto3.util.setEnumType(FolderState, 'container.v1.FolderState', [
  { no: 0, name: 'FOLDER_STATE_UNSPECIFIED' },
  { no: 1, name: 'FOLDER_STATE_ACTIVE' },
  { no: 2, name: 'FOLDER_STATE_DRAFT' },
  { no: 3, name: 'FOLDER_STATE_ARCHIVED' }
])

/**
 * @generated from message container.v1.Folder
 */
export class Folder extends Message<Folder> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string name = 2;
   */
  name = ''

  /**
   * @generated from field: string description = 3;
   */
  description = ''

  /**
   * @generated from field: string path = 4;
   */
  path = ''

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId = ''

  /**
   * @generated from field: string owner_id = 6;
   */
  ownerId = ''

  /**
   * @generated from field: container.v1.ContainerType container_type = 7;
   */
  containerType = ContainerType.UNSPECIFIED

  /**
   * @generated from field: container.v1.FolderState state = 8;
   */
  state = FolderState.UNSPECIFIED

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 9;
   */
  creationMethod = CreationMethod.UNSPECIFIED

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[] = []

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: int32 num_folders = 13;
   */
  numFolders = 0

  /**
   * @generated from field: int32 num_assets = 14;
   */
  numAssets = 0

  /**
   * @generated from field: string org_id = 15;
   */
  orgId = ''

  /**
   * @generated from field: string workspace_id = 16;
   */
  workspaceId = ''

  constructor(data?: PartialMessage<Folder>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.Folder'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'path', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'creator_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'owner_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 7, name: 'container_type', kind: 'enum', T: proto3.getEnumType(ContainerType) },
    { no: 8, name: 'state', kind: 'enum', T: proto3.getEnumType(FolderState) },
    { no: 9, name: 'creation_method', kind: 'enum', T: proto3.getEnumType(CreationMethod) },
    { no: 10, name: 'tags', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: 'created_at', kind: 'message', T: Timestamp },
    { no: 12, name: 'updated_at', kind: 'message', T: Timestamp, opt: true },
    { no: 13, name: 'num_folders', kind: 'scalar', T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: 'num_assets', kind: 'scalar', T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: 'org_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 16, name: 'workspace_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Folder {
    return new Folder().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Folder {
    return new Folder().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Folder {
    return new Folder().fromJsonString(jsonString, options)
  }

  static equals(
    a: Folder | PlainMessage<Folder> | undefined,
    b: Folder | PlainMessage<Folder> | undefined
  ): boolean {
    return proto3.util.equals(Folder, a, b)
  }
}

/**
 * @generated from message container.v1.Workspace
 */
export class Workspace extends Message<Workspace> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string name = 2;
   */
  name = ''

  /**
   * @generated from field: string description = 3;
   */
  description = ''

  /**
   * @generated from field: string path = 4;
   */
  path = ''

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId = ''

  /**
   * @generated from field: container.v1.ContainerType container_type = 6;
   */
  containerType = ContainerType.UNSPECIFIED

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 9;
   */
  creationMethod = CreationMethod.UNSPECIFIED

  /**
   * @generated from field: int32 num_folders = 10;
   */
  numFolders = 0

  /**
   * @generated from field: int32 num_assets = 11;
   */
  numAssets = 0

  /**
   * @generated from field: string org_id = 12;
   */
  orgId = ''

  constructor(data?: PartialMessage<Workspace>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.Workspace'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'path', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'creator_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'container_type', kind: 'enum', T: proto3.getEnumType(ContainerType) },
    { no: 7, name: 'created_at', kind: 'message', T: Timestamp },
    { no: 8, name: 'updated_at', kind: 'message', T: Timestamp, opt: true },
    { no: 9, name: 'creation_method', kind: 'enum', T: proto3.getEnumType(CreationMethod) },
    { no: 10, name: 'num_folders', kind: 'scalar', T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: 'num_assets', kind: 'scalar', T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: 'org_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Workspace {
    return new Workspace().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Workspace {
    return new Workspace().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Workspace {
    return new Workspace().fromJsonString(jsonString, options)
  }

  static equals(
    a: Workspace | PlainMessage<Workspace> | undefined,
    b: Workspace | PlainMessage<Workspace> | undefined
  ): boolean {
    return proto3.util.equals(Workspace, a, b)
  }
}

/**
 * @generated from message container.v1.Org
 */
export class Org extends Message<Org> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string name = 2;
   */
  name = ''

  /**
   * @generated from field: string description = 3;
   */
  description = ''

  /**
   * @generated from field: string path = 4;
   */
  path = ''

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId = ''

  /**
   * @generated from field: container.v1.ContainerType container_type = 6;
   */
  containerType = ContainerType.UNSPECIFIED

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 9;
   */
  creationMethod = CreationMethod.UNSPECIFIED

  /**
   * @generated from field: int32 num_workspaces = 10;
   */
  numWorkspaces = 0

  /**
   * @generated from field: int32 num_assets = 11;
   */
  numAssets = 0

  constructor(data?: PartialMessage<Org>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.Org'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'path', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'creator_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'container_type', kind: 'enum', T: proto3.getEnumType(ContainerType) },
    { no: 7, name: 'created_at', kind: 'message', T: Timestamp },
    { no: 8, name: 'updated_at', kind: 'message', T: Timestamp, opt: true },
    { no: 9, name: 'creation_method', kind: 'enum', T: proto3.getEnumType(CreationMethod) },
    { no: 10, name: 'num_workspaces', kind: 'scalar', T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: 'num_assets', kind: 'scalar', T: 5 /* ScalarType.INT32 */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Org {
    return new Org().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Org {
    return new Org().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Org {
    return new Org().fromJsonString(jsonString, options)
  }

  static equals(
    a: Org | PlainMessage<Org> | undefined,
    b: Org | PlainMessage<Org> | undefined
  ): boolean {
    return proto3.util.equals(Org, a, b)
  }
}

/**
 * @generated from message container.v1.GetOrgRequest
 */
export class GetOrgRequest extends Message<GetOrgRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  constructor(data?: PartialMessage<GetOrgRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.GetOrgRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrgRequest {
    return new GetOrgRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrgRequest {
    return new GetOrgRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrgRequest {
    return new GetOrgRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetOrgRequest | PlainMessage<GetOrgRequest> | undefined,
    b: GetOrgRequest | PlainMessage<GetOrgRequest> | undefined
  ): boolean {
    return proto3.util.equals(GetOrgRequest, a, b)
  }
}

/**
 * @generated from message container.v1.GetWorkspaceRequest
 */
export class GetWorkspaceRequest extends Message<GetWorkspaceRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  constructor(data?: PartialMessage<GetWorkspaceRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.GetWorkspaceRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkspaceRequest {
    return new GetWorkspaceRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkspaceRequest {
    return new GetWorkspaceRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): GetWorkspaceRequest {
    return new GetWorkspaceRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetWorkspaceRequest | PlainMessage<GetWorkspaceRequest> | undefined,
    b: GetWorkspaceRequest | PlainMessage<GetWorkspaceRequest> | undefined
  ): boolean {
    return proto3.util.equals(GetWorkspaceRequest, a, b)
  }
}

/**
 * @generated from message container.v1.GetFolderRequest
 */
export class GetFolderRequest extends Message<GetFolderRequest> {
  /**
   * @generated from oneof container.v1.GetFolderRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string folder_id = 1;
         */
        value: string
        case: 'folderId'
      }
    | {
        /**
         * @generated from field: string folder_path = 2;
         */
        value: string
        case: 'folderPath'
      }
    | { case: undefined; value?: undefined } = { case: undefined }

  constructor(data?: PartialMessage<GetFolderRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.GetFolderRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folder_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' },
    { no: 2, name: 'folder_path', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFolderRequest {
    return new GetFolderRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFolderRequest {
    return new GetFolderRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFolderRequest {
    return new GetFolderRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetFolderRequest | PlainMessage<GetFolderRequest> | undefined,
    b: GetFolderRequest | PlainMessage<GetFolderRequest> | undefined
  ): boolean {
    return proto3.util.equals(GetFolderRequest, a, b)
  }
}

/**
 * @generated from message container.v1.ListWorkspacesRequest
 */
export class ListWorkspacesRequest extends Message<ListWorkspacesRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: optional common.v1.PaginationArguments paginate = 2;
   */
  paginate?: PaginationArguments

  constructor(data?: PartialMessage<ListWorkspacesRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.ListWorkspacesRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'paginate', kind: 'message', T: PaginationArguments, opt: true }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: ListWorkspacesRequest | PlainMessage<ListWorkspacesRequest> | undefined,
    b: ListWorkspacesRequest | PlainMessage<ListWorkspacesRequest> | undefined
  ): boolean {
    return proto3.util.equals(ListWorkspacesRequest, a, b)
  }
}

/**
 * @generated from message container.v1.FolderFilter
 */
export class FolderFilter extends Message<FolderFilter> {
  /**
   * returns folders only in the provides states
   *
   * @generated from field: repeated container.v1.FolderState states = 1;
   */
  states: FolderState[] = []

  /**
   * returns folders by the creator(s)
   *
   * @generated from field: repeated string creator_ids = 2;
   */
  creatorIds: string[] = []

  /**
   * returns folders by the owner(s)
   *
   * @generated from field: repeated string owner_ids = 3;
   */
  ownerIds: string[] = []

  /**
   * CreatedAtDateRange scopes the response to folders created in the specified range. The filter is exclusive
   *
   * When start_date is empty the filtering will get everything created up to end_date
   * When end_date is empty the filtering will get everything created from the start_date up until now
   *
   * @generated from field: optional asset.v1.DateRange created_at_date_range = 4;
   */
  createdAtDateRange?: DateRange

  /**
   * returns folders that match the supplied name prefix
   *
   * @generated from field: string name_prefix = 5;
   */
  namePrefix = ''

  constructor(data?: PartialMessage<FolderFilter>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.FolderFilter'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'states', kind: 'enum', T: proto3.getEnumType(FolderState), repeated: true },
    { no: 2, name: 'creator_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: 'owner_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: 'created_at_date_range', kind: 'message', T: DateRange, opt: true },
    { no: 5, name: 'name_prefix', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FolderFilter {
    return new FolderFilter().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FolderFilter {
    return new FolderFilter().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FolderFilter {
    return new FolderFilter().fromJsonString(jsonString, options)
  }

  static equals(
    a: FolderFilter | PlainMessage<FolderFilter> | undefined,
    b: FolderFilter | PlainMessage<FolderFilter> | undefined
  ): boolean {
    return proto3.util.equals(FolderFilter, a, b)
  }
}

/**
 * @generated from message container.v1.ListFoldersRequest
 */
export class ListFoldersRequest extends Message<ListFoldersRequest> {
  /**
   * @generated from oneof container.v1.ListFoldersRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string org_id = 1;
         */
        value: string
        case: 'orgId'
      }
    | {
        /**
         * @generated from field: string workspace_id = 2;
         */
        value: string
        case: 'workspaceId'
      }
    | {
        /**
         * @generated from field: string folder_id = 3;
         */
        value: string
        case: 'folderId'
      }
    | { case: undefined; value?: undefined } = { case: undefined }

  /**
   * @generated from field: optional common.v1.PaginationArguments paginate = 4;
   */
  paginate?: PaginationArguments

  /**
   * @generated from field: optional container.v1.FolderFilter filter = 5;
   */
  filter?: FolderFilter

  constructor(data?: PartialMessage<ListFoldersRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.ListFoldersRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'org_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' },
    { no: 2, name: 'workspace_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' },
    { no: 3, name: 'folder_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' },
    { no: 4, name: 'paginate', kind: 'message', T: PaginationArguments, opt: true },
    { no: 5, name: 'filter', kind: 'message', T: FolderFilter, opt: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFoldersRequest {
    return new ListFoldersRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFoldersRequest {
    return new ListFoldersRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): ListFoldersRequest {
    return new ListFoldersRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: ListFoldersRequest | PlainMessage<ListFoldersRequest> | undefined,
    b: ListFoldersRequest | PlainMessage<ListFoldersRequest> | undefined
  ): boolean {
    return proto3.util.equals(ListFoldersRequest, a, b)
  }
}

/**
 * @generated from message container.v1.CountFoldersRequest
 */
export class CountFoldersRequest extends Message<CountFoldersRequest> {
  /**
   * @generated from oneof container.v1.CountFoldersRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string org_id = 1;
         */
        value: string
        case: 'orgId'
      }
    | {
        /**
         * @generated from field: string workspace_id = 2;
         */
        value: string
        case: 'workspaceId'
      }
    | {
        /**
         * @generated from field: string folder_id = 3;
         */
        value: string
        case: 'folderId'
      }
    | { case: undefined; value?: undefined } = { case: undefined }

  /**
   * @generated from field: optional container.v1.FolderFilter filter = 5;
   */
  filter?: FolderFilter

  constructor(data?: PartialMessage<CountFoldersRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.CountFoldersRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'org_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' },
    { no: 2, name: 'workspace_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' },
    { no: 3, name: 'folder_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, oneof: 'id' },
    { no: 5, name: 'filter', kind: 'message', T: FolderFilter, opt: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountFoldersRequest {
    return new CountFoldersRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountFoldersRequest {
    return new CountFoldersRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): CountFoldersRequest {
    return new CountFoldersRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: CountFoldersRequest | PlainMessage<CountFoldersRequest> | undefined,
    b: CountFoldersRequest | PlainMessage<CountFoldersRequest> | undefined
  ): boolean {
    return proto3.util.equals(CountFoldersRequest, a, b)
  }
}

/**
 * @generated from message container.v1.CreateFolderRequest
 */
export class CreateFolderRequest extends Message<CreateFolderRequest> {
  /**
   * ID is an optional bring your own id for the folder
   *
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * Name is the name used when displaying the folder
   *
   * - The folder's path is derived by appending the name to the parent path seperated by "/"
   *
   * @generated from field: string name = 4;
   */
  name = ''

  /**
   * ParentPath represents the path of the org, workspace, or folder the new folder should be placed in
   *
   * - If the parent_path is empty then the folder is placed at the root in the user's org
   *
   * @generated from field: string parent_path = 2;
   */
  parentPath = ''

  /**
   * State is a required field to create create the folder in the supplied FolderState
   *
   * - Default is that the folder is created in the active state
   *
   * @generated from field: container.v1.FolderState state = 3;
   */
  state = FolderState.UNSPECIFIED

  /**
   * Description is an optional description associated to the folder.
   *
   * @generated from field: optional string description = 5;
   */
  description?: string

  /**
   * Tags associated to the folder
   *
   * @generated from field: repeated string tags = 6;
   */
  tags: string[] = []

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 7;
   */
  creationMethod = CreationMethod.UNSPECIFIED

  /**
   * @generated from field: string owner_id = 8;
   */
  ownerId = ''

  constructor(data?: PartialMessage<CreateFolderRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.CreateFolderRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'parent_path', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'state', kind: 'enum', T: proto3.getEnumType(FolderState) },
    { no: 5, name: 'description', kind: 'scalar', T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: 'tags', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: 'creation_method', kind: 'enum', T: proto3.getEnumType(CreationMethod) },
    { no: 8, name: 'owner_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateFolderRequest {
    return new CreateFolderRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateFolderRequest {
    return new CreateFolderRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): CreateFolderRequest {
    return new CreateFolderRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: CreateFolderRequest | PlainMessage<CreateFolderRequest> | undefined,
    b: CreateFolderRequest | PlainMessage<CreateFolderRequest> | undefined
  ): boolean {
    return proto3.util.equals(CreateFolderRequest, a, b)
  }
}

/**
 * @generated from message container.v1.UpdateFolderRequest
 */
export class UpdateFolderRequest extends Message<UpdateFolderRequest> {
  /**
   * The id of the folder
   *
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * Optionally update the folder name
   *
   * @generated from field: optional string name = 3;
   */
  name?: string

  /**
   * Optionally update the folder description
   *
   * @generated from field: optional string description = 4;
   */
  description?: string

  /**
   * Optionally update the owner
   *
   * @generated from field: optional string owner_id = 5;
   */
  ownerId?: string

  constructor(data?: PartialMessage<UpdateFolderRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.UpdateFolderRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: 'description', kind: 'scalar', T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: 'owner_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, opt: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateFolderRequest {
    return new UpdateFolderRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateFolderRequest {
    return new UpdateFolderRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): UpdateFolderRequest {
    return new UpdateFolderRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateFolderRequest | PlainMessage<UpdateFolderRequest> | undefined,
    b: UpdateFolderRequest | PlainMessage<UpdateFolderRequest> | undefined
  ): boolean {
    return proto3.util.equals(UpdateFolderRequest, a, b)
  }
}

/**
 * @generated from message container.v1.ArchiveFolderRequest
 */
export class ArchiveFolderRequest extends Message<ArchiveFolderRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  constructor(data?: PartialMessage<ArchiveFolderRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.ArchiveFolderRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveFolderRequest {
    return new ArchiveFolderRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveFolderRequest {
    return new ArchiveFolderRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): ArchiveFolderRequest {
    return new ArchiveFolderRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: ArchiveFolderRequest | PlainMessage<ArchiveFolderRequest> | undefined,
    b: ArchiveFolderRequest | PlainMessage<ArchiveFolderRequest> | undefined
  ): boolean {
    return proto3.util.equals(ArchiveFolderRequest, a, b)
  }
}

/**
 * @generated from message container.v1.RestoreFolderRequest
 */
export class RestoreFolderRequest extends Message<RestoreFolderRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  constructor(data?: PartialMessage<RestoreFolderRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.RestoreFolderRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RestoreFolderRequest {
    return new RestoreFolderRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RestoreFolderRequest {
    return new RestoreFolderRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): RestoreFolderRequest {
    return new RestoreFolderRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: RestoreFolderRequest | PlainMessage<RestoreFolderRequest> | undefined,
    b: RestoreFolderRequest | PlainMessage<RestoreFolderRequest> | undefined
  ): boolean {
    return proto3.util.equals(RestoreFolderRequest, a, b)
  }
}

/**
 * @generated from message container.v1.DeleteFolderRequest
 */
export class DeleteFolderRequest extends Message<DeleteFolderRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  constructor(data?: PartialMessage<DeleteFolderRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.DeleteFolderRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteFolderRequest {
    return new DeleteFolderRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteFolderRequest {
    return new DeleteFolderRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): DeleteFolderRequest {
    return new DeleteFolderRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteFolderRequest | PlainMessage<DeleteFolderRequest> | undefined,
    b: DeleteFolderRequest | PlainMessage<DeleteFolderRequest> | undefined
  ): boolean {
    return proto3.util.equals(DeleteFolderRequest, a, b)
  }
}

/**
 * @generated from message container.v1.DeleteFoldersRequest
 */
export class DeleteFoldersRequest extends Message<DeleteFoldersRequest> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = []

  constructor(data?: PartialMessage<DeleteFoldersRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.DeleteFoldersRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteFoldersRequest {
    return new DeleteFoldersRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteFoldersRequest {
    return new DeleteFoldersRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): DeleteFoldersRequest {
    return new DeleteFoldersRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteFoldersRequest | PlainMessage<DeleteFoldersRequest> | undefined,
    b: DeleteFoldersRequest | PlainMessage<DeleteFoldersRequest> | undefined
  ): boolean {
    return proto3.util.equals(DeleteFoldersRequest, a, b)
  }
}

/**
 * @generated from message container.v1.MoveFolderRequest
 */
export class MoveFolderRequest extends Message<MoveFolderRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string parent_path = 2;
   */
  parentPath = ''

  constructor(data?: PartialMessage<MoveFolderRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.MoveFolderRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'parent_path', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MoveFolderRequest {
    return new MoveFolderRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MoveFolderRequest {
    return new MoveFolderRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MoveFolderRequest {
    return new MoveFolderRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: MoveFolderRequest | PlainMessage<MoveFolderRequest> | undefined,
    b: MoveFolderRequest | PlainMessage<MoveFolderRequest> | undefined
  ): boolean {
    return proto3.util.equals(MoveFolderRequest, a, b)
  }
}

/**
 * @generated from message container.v1.MoveFoldersRequest
 */
export class MoveFoldersRequest extends Message<MoveFoldersRequest> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = []

  /**
   * @generated from field: string parent_path = 2;
   */
  parentPath = ''

  constructor(data?: PartialMessage<MoveFoldersRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.MoveFoldersRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: 'parent_path', kind: 'scalar', T: 9 /* ScalarType.STRING */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MoveFoldersRequest {
    return new MoveFoldersRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MoveFoldersRequest {
    return new MoveFoldersRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): MoveFoldersRequest {
    return new MoveFoldersRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: MoveFoldersRequest | PlainMessage<MoveFoldersRequest> | undefined,
    b: MoveFoldersRequest | PlainMessage<MoveFoldersRequest> | undefined
  ): boolean {
    return proto3.util.equals(MoveFoldersRequest, a, b)
  }
}

/**
 * @generated from message container.v1.GetOrgResponse
 */
export class GetOrgResponse extends Message<GetOrgResponse> {
  /**
   * @generated from field: container.v1.Org org = 1;
   */
  org?: Org

  constructor(data?: PartialMessage<GetOrgResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.GetOrgResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'org', kind: 'message', T: Org }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrgResponse {
    return new GetOrgResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrgResponse {
    return new GetOrgResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrgResponse {
    return new GetOrgResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetOrgResponse | PlainMessage<GetOrgResponse> | undefined,
    b: GetOrgResponse | PlainMessage<GetOrgResponse> | undefined
  ): boolean {
    return proto3.util.equals(GetOrgResponse, a, b)
  }
}

/**
 * @generated from message container.v1.GetWorkspaceResponse
 */
export class GetWorkspaceResponse extends Message<GetWorkspaceResponse> {
  /**
   * @generated from field: container.v1.Workspace workspace = 1;
   */
  workspace?: Workspace

  constructor(data?: PartialMessage<GetWorkspaceResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.GetWorkspaceResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'workspace', kind: 'message', T: Workspace }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkspaceResponse {
    return new GetWorkspaceResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkspaceResponse {
    return new GetWorkspaceResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): GetWorkspaceResponse {
    return new GetWorkspaceResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetWorkspaceResponse | PlainMessage<GetWorkspaceResponse> | undefined,
    b: GetWorkspaceResponse | PlainMessage<GetWorkspaceResponse> | undefined
  ): boolean {
    return proto3.util.equals(GetWorkspaceResponse, a, b)
  }
}

/**
 * @generated from message container.v1.GetFolderResponse
 */
export class GetFolderResponse extends Message<GetFolderResponse> {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder

  constructor(data?: PartialMessage<GetFolderResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.GetFolderResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folder', kind: 'message', T: Folder }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFolderResponse {
    return new GetFolderResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFolderResponse {
    return new GetFolderResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFolderResponse {
    return new GetFolderResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetFolderResponse | PlainMessage<GetFolderResponse> | undefined,
    b: GetFolderResponse | PlainMessage<GetFolderResponse> | undefined
  ): boolean {
    return proto3.util.equals(GetFolderResponse, a, b)
  }
}

/**
 * @generated from message container.v1.ListWorkspacesResponse
 */
export class ListWorkspacesResponse extends Message<ListWorkspacesResponse> {
  /**
   * @generated from field: repeated container.v1.Workspace workspaces = 1;
   */
  workspaces: Workspace[] = []

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo

  constructor(data?: PartialMessage<ListWorkspacesResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.ListWorkspacesResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'workspaces', kind: 'message', T: Workspace, repeated: true },
    { no: 2, name: 'page_info', kind: 'message', T: PaginationPageInfo }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromBinary(bytes, options)
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>
  ): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: ListWorkspacesResponse | PlainMessage<ListWorkspacesResponse> | undefined,
    b: ListWorkspacesResponse | PlainMessage<ListWorkspacesResponse> | undefined
  ): boolean {
    return proto3.util.equals(ListWorkspacesResponse, a, b)
  }
}

/**
 * @generated from message container.v1.ListFoldersResponse
 */
export class ListFoldersResponse extends Message<ListFoldersResponse> {
  /**
   * @generated from field: repeated container.v1.Folder folders = 1;
   */
  folders: Folder[] = []

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo

  constructor(data?: PartialMessage<ListFoldersResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.ListFoldersResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folders', kind: 'message', T: Folder, repeated: true },
    { no: 2, name: 'page_info', kind: 'message', T: PaginationPageInfo }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFoldersResponse {
    return new ListFoldersResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFoldersResponse {
    return new ListFoldersResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): ListFoldersResponse {
    return new ListFoldersResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: ListFoldersResponse | PlainMessage<ListFoldersResponse> | undefined,
    b: ListFoldersResponse | PlainMessage<ListFoldersResponse> | undefined
  ): boolean {
    return proto3.util.equals(ListFoldersResponse, a, b)
  }
}

/**
 * @generated from message container.v1.CountFoldersResponse
 */
export class CountFoldersResponse extends Message<CountFoldersResponse> {
  /**
   * @generated from field: int32 num_folders = 1;
   */
  numFolders = 0

  constructor(data?: PartialMessage<CountFoldersResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.CountFoldersResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'num_folders', kind: 'scalar', T: 5 /* ScalarType.INT32 */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountFoldersResponse {
    return new CountFoldersResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountFoldersResponse {
    return new CountFoldersResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): CountFoldersResponse {
    return new CountFoldersResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: CountFoldersResponse | PlainMessage<CountFoldersResponse> | undefined,
    b: CountFoldersResponse | PlainMessage<CountFoldersResponse> | undefined
  ): boolean {
    return proto3.util.equals(CountFoldersResponse, a, b)
  }
}

/**
 * @generated from message container.v1.CreateFolderResponse
 */
export class CreateFolderResponse extends Message<CreateFolderResponse> {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder

  constructor(data?: PartialMessage<CreateFolderResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.CreateFolderResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folder', kind: 'message', T: Folder }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateFolderResponse {
    return new CreateFolderResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateFolderResponse {
    return new CreateFolderResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): CreateFolderResponse {
    return new CreateFolderResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: CreateFolderResponse | PlainMessage<CreateFolderResponse> | undefined,
    b: CreateFolderResponse | PlainMessage<CreateFolderResponse> | undefined
  ): boolean {
    return proto3.util.equals(CreateFolderResponse, a, b)
  }
}

/**
 * @generated from message container.v1.ArchiveFolderResponse
 */
export class ArchiveFolderResponse extends Message<ArchiveFolderResponse> {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder

  constructor(data?: PartialMessage<ArchiveFolderResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.ArchiveFolderResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folder', kind: 'message', T: Folder }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): ArchiveFolderResponse {
    return new ArchiveFolderResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveFolderResponse {
    return new ArchiveFolderResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): ArchiveFolderResponse {
    return new ArchiveFolderResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: ArchiveFolderResponse | PlainMessage<ArchiveFolderResponse> | undefined,
    b: ArchiveFolderResponse | PlainMessage<ArchiveFolderResponse> | undefined
  ): boolean {
    return proto3.util.equals(ArchiveFolderResponse, a, b)
  }
}

/**
 * @generated from message container.v1.RestoreFolderResponse
 */
export class RestoreFolderResponse extends Message<RestoreFolderResponse> {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder

  constructor(data?: PartialMessage<RestoreFolderResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.RestoreFolderResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folder', kind: 'message', T: Folder }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): RestoreFolderResponse {
    return new RestoreFolderResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RestoreFolderResponse {
    return new RestoreFolderResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): RestoreFolderResponse {
    return new RestoreFolderResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: RestoreFolderResponse | PlainMessage<RestoreFolderResponse> | undefined,
    b: RestoreFolderResponse | PlainMessage<RestoreFolderResponse> | undefined
  ): boolean {
    return proto3.util.equals(RestoreFolderResponse, a, b)
  }
}

/**
 * @generated from message container.v1.MoveFolderResponse
 */
export class MoveFolderResponse extends Message<MoveFolderResponse> {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder

  constructor(data?: PartialMessage<MoveFolderResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.MoveFolderResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folder', kind: 'message', T: Folder }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MoveFolderResponse {
    return new MoveFolderResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MoveFolderResponse {
    return new MoveFolderResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): MoveFolderResponse {
    return new MoveFolderResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: MoveFolderResponse | PlainMessage<MoveFolderResponse> | undefined,
    b: MoveFolderResponse | PlainMessage<MoveFolderResponse> | undefined
  ): boolean {
    return proto3.util.equals(MoveFolderResponse, a, b)
  }
}

/**
 * @generated from message container.v1.MoveFoldersResponse
 */
export class MoveFoldersResponse extends Message<MoveFoldersResponse> {
  /**
   * @generated from field: repeated container.v1.Folder folders = 1;
   */
  folders: Folder[] = []

  constructor(data?: PartialMessage<MoveFoldersResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.MoveFoldersResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folders', kind: 'message', T: Folder, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MoveFoldersResponse {
    return new MoveFoldersResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MoveFoldersResponse {
    return new MoveFoldersResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): MoveFoldersResponse {
    return new MoveFoldersResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: MoveFoldersResponse | PlainMessage<MoveFoldersResponse> | undefined,
    b: MoveFoldersResponse | PlainMessage<MoveFoldersResponse> | undefined
  ): boolean {
    return proto3.util.equals(MoveFoldersResponse, a, b)
  }
}

/**
 * @generated from message container.v1.UpdateFolderResponse
 */
export class UpdateFolderResponse extends Message<UpdateFolderResponse> {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder

  constructor(data?: PartialMessage<UpdateFolderResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.UpdateFolderResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'folder', kind: 'message', T: Folder }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateFolderResponse {
    return new UpdateFolderResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateFolderResponse {
    return new UpdateFolderResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): UpdateFolderResponse {
    return new UpdateFolderResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateFolderResponse | PlainMessage<UpdateFolderResponse> | undefined,
    b: UpdateFolderResponse | PlainMessage<UpdateFolderResponse> | undefined
  ): boolean {
    return proto3.util.equals(UpdateFolderResponse, a, b)
  }
}

/**
 * @generated from message container.v1.DeleteFolderResponse
 */
export class DeleteFolderResponse extends Message<DeleteFolderResponse> {
  constructor(data?: PartialMessage<DeleteFolderResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.DeleteFolderResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteFolderResponse {
    return new DeleteFolderResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteFolderResponse {
    return new DeleteFolderResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): DeleteFolderResponse {
    return new DeleteFolderResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteFolderResponse | PlainMessage<DeleteFolderResponse> | undefined,
    b: DeleteFolderResponse | PlainMessage<DeleteFolderResponse> | undefined
  ): boolean {
    return proto3.util.equals(DeleteFolderResponse, a, b)
  }
}

/**
 * @generated from message container.v1.DeleteFoldersResponse
 */
export class DeleteFoldersResponse extends Message<DeleteFoldersResponse> {
  constructor(data?: PartialMessage<DeleteFoldersResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'container.v1.DeleteFoldersResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): DeleteFoldersResponse {
    return new DeleteFoldersResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteFoldersResponse {
    return new DeleteFoldersResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): DeleteFoldersResponse {
    return new DeleteFoldersResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteFoldersResponse | PlainMessage<DeleteFoldersResponse> | undefined,
    b: DeleteFoldersResponse | PlainMessage<DeleteFoldersResponse> | undefined
  ): boolean {
    return proto3.util.equals(DeleteFoldersResponse, a, b)
  }
}
